const getTeamUrl = () => `/teams/${window.teamDomain}`;

const getKaiDashboardUrl = () => `/teams/${window.teamDomain}/kai-dashboard`;

const getApiTeamKaiExcludedCategoriesUrl = () => `/api${getTeamUrl()}/kai-excluded-categories`;

const getTeamApiUrl = () => `/api/teams/${window.teamId}`;

const getTeamSettingsUrl = () => `${getTeamUrl()}/edit`;

const getTeamUsersUrl = () => `${getTeamUrl()}/users`;

const getUserProfileUrl = (userId) => `${getTeamUrl()}/users/${userId}`;

const getTeamIntegrationsUrl = () => `${getTeamUrl()}/integrations`;

const getTeamBillingUrl = () => `${getTeamUrl()}/subscriptions`;

const getSetupGuideUrl = () => `${getTeamUrl()}/setup-guide`;

const getOnboardingTeamUrl = () => `${getTeamUrl()}/onboarding/team`;

const getOnboardingSlackIntegrationUrl = () => `${getTeamUrl()}/onboarding/slack`;

const getOnboardingGsuiteIntegrationUrl = () => `${getTeamUrl()}/onboarding/google`;

const getOnboardingKaiUrl = () => `${getTeamUrl()}/onboarding/kai`;

const getOnboardingEnableKaiUrl = () => `${getTeamUrl()}/onboarding/enable-kai`;

const getOnboardingCreateFirstQuestionUrl = () => `${getTeamUrl()}/onboarding/first-question`;

const getDraftsUrl = () => `${getTeamUrl()}/drafts`;

const getPagesUrl = () => `${getTeamUrl()}/pages`;

const getPagesOwnerUrl = () => `${getTeamUrl()}/pages-owner`;

const getUncategorizedPagesUrl = () => `${getPagesUrl()}?filter=uncategorized`;

const getArchivedPagesUrl = () => `${getTeamUrl()}/archived-pages`;

const getArchivedPagesSearchViewUrl = () => `${getTeamUrl()}/pages?tab=pages&page=1&status=archived`;

const getArchivedPageUrl = (pageId) => `${getArchivedPagesUrl()}/${pageId}`;

const getRestorePageUrl = (pageId) => `${getArchivedPageUrl(pageId)}/restore`;

const getSuggestionsUrl = () => `${getTeamUrl()}/suggestions`;

const getQuestionsUrl = () => `${getTeamUrl()}/questions`;

const getTeamSlackQaChannelsUrl = () => `${getTeamUrl()}/slack-qa-channels`;

const getTeamGoogleFoldersUrl = () => `${getTeamUrl()}/google-drive-folders`;

const getGeneratedQuestionUrl = (generatedQuestionId) => `${getTeamUrl()}/generated-questions/${generatedQuestionId}`;

const getGeneratedQuestionsUrl = () => `${getTeamUrl()}/questions?tab=generated`;

const getKaiSlackQuestionsUrl = () => `${getTeamUrl()}/questions?tab=kai_slack`;

const getKaiSlackQuestionUrl = (kaiSlackQuestionId) => `${getTeamUrl()}/kai-slack-questions/${kaiSlackQuestionId}`;

const getQuestionUrl = (questionId) => `${getTeamUrl()}/questions/${questionId}`;

const getQuestionUrlAnswerAction = (questionId) => `${getQuestionUrl(questionId)}?answerQuestion=true`;

const getTemplatesUrl = () => `${getTeamUrl()}/templates`;

const getDraftUrl = (draftId) => `${getDraftsUrl()}/${draftId}`;

const getEditDraftUrl = (draftId) => `${getDraftUrl(draftId)}/edit`;

const getExportUrl = () => `${getTeamUrl()}/exports`;

const getDraftEditApprovalUrl = (draftId) => `${getDraftUrl(draftId)}/request-approval`;

const getContentSuggestionsUrl = () => `${getTeamUrl()}/content-suggestions`;

const getCreateDraftUrl = () => `${getDraftsUrl()}/create`;

const getCreateDraftUrlWithQuestionId = (questionId) => `${getDraftsUrl()}/create?questionId=${questionId}`;

const getCreateDraftUrlFromCategoryId = (categoryId) => `${getDraftsUrl()}/create?categoryId=${categoryId}`;

const getCreateDraftUrlFromFolderId = (folderId) => `${getDraftsUrl()}/create?folderId=${folderId}`;

const getCreateDraftUrlFromTemplateId = (templateId) => `${getTeamUrl()}/drafts/create?templateId=${templateId}`;

const getCreateDraftUrlFromCategoryIdAndFolderId = (categoryId, folderId) => `${getDraftsUrl()}/create?categoryId=${categoryId}&folderId=${folderId}`;

const getCreateDraftUrlFromPageId = (pageId) => `${getDraftsUrl()}/create?pageId=${pageId}`;

const getCreateDraftUrlFromSuggestionId = (suggestionId) => `${getDraftsUrl()}/create?suggestionId=${suggestionId}`;

const getCreateSuggestionUrlFromCategoryId = (categoryId) => `${getTeamUrl()}/suggestions/create?categoryId=${categoryId}`;

const getCreateSuggestionUrlFromCategoryIdAndFolderId = (
    categoryId,
    folderId,
) => `${getCreateSuggestionUrlFromCategoryId(categoryId)}&folderId=${folderId}`;

const getCreateTemplateUrlFromPageId = (pageId) => `${getDraftsUrl()}/create?templatePageId=${pageId}`;

const getCreateCategoryUrl = () => `${getTeamUrl()}/categories/create`;

const getCategoriesUrl = () => `${getTeamUrl()}/categories`;

const getCategoryUrl = (categoryId) => `${getTeamUrl()}/categories/${categoryId}`;

const getFolderUrl = (categoryId, folderId) => `${getCategoryUrl(categoryId)}/folders/${folderId}`;

const getExternalResourceUrl = (externalResourceId) => `${getTeamUrl()}/external-resources/${externalResourceId}`;

const getRestoreExternalResourceUrl = (externalResourceId) => `${getTeamUrl()}/archived-links/${externalResourceId}/restore`;

const getArchivedExternalResourceUrl = (externalResourceId) => `${getTeamUrl()}/archived-links/${externalResourceId}`;

const getDocumentUrl = (documentId) => `${getTeamUrl()}/documents/${documentId}`;

const getDocumentsUrl = () => `${getTeamUrl()}/documents`;

const getLinksUrl = () => `${getTeamUrl()}/links`;

const getArchivedDocumentUrl = (documentId) => `${getTeamUrl()}/archived-documents/${documentId}`;

const getRestoreDocumentUrl = (documentId) => `${getTeamUrl()}/archived-documents/${documentId}/restore`;

const getSlackFilesUrl = () => `${getTeamUrl()}/slack-files`;

const getSuggestionUrl = (suggestionId) => `${getTeamUrl()}/suggestions/${suggestionId}`;

const getSuggestionEditUrl = (suggestionId) => `${getSuggestionUrl(suggestionId)}/edit`;

const getSuggestionCloseUrl = (suggestionId) => `${getSuggestionUrl(suggestionId)}`;

const getSubcategoryUrl = (subcategoryId) => `${getTeamUrl()}/subcategories/${subcategoryId}`;

const getSubcategoriesUrl = () => `${getTeamUrl()}/subcategories`;

const getSubcategoryEditUrl = (subcategoryId) => `${getSubcategoryUrl(subcategoryId)}/edit`;

const getCategoryEditUrl = (categoryId) => `${getCategoryUrl(categoryId)}/edit`;

const getCategoryPinUrl = (categoryId) => `${getCategoryUrl(categoryId)}/pin`;

const getUserOwnedPagesUrl = (userId) => `${getTeamUrl()}/users/${userId}/owned-pages`;

const getUserOwnedCategoriesUrl = (userId) => `${getTeamUrl()}/users/${userId}/owned-categories`;

const getUserSuggestionsUrl = (userId) => `${getTeamUrl()}/users/${userId}/suggestions`;

const getUserAnsweredQuestionsUrl = (userId) => `${getTeamUrl()}/users/${userId}/answered-questions`;

const getUserLinksUrl = (userId) => `${getTeamUrl()}/users/${userId}/external-resources`;

const getUserDocumentsUrl = (userId) => `${getTeamUrl()}/users/${userId}/documents`;

const getSluggedPagesUrl = () => `${getTeamUrl()}/slugged-pages`;

const getPageSearchUrl = (query) => `${getPagesUrl()}?q=${window.encodeURIComponent(query)}`;

const getApiActivitiesUrl = () => `/api${getTeamUrl()}/activities`;

const getApiAnswerThankYousUrl = (answer_id) => `/api${getTeamUrl()}/answers/${answer_id}/thank-yous`;

const getApiAnswerThankYouUrl = (answer_id, thankyou_id) => `/api${getTeamUrl()}/answers/${answer_id}/thank-yous/${thankyou_id}`;

const getApiBookmarkUrl = (userId) => `/api${getTeamUrl()}/users/${userId}/bookmarks`;

const getApiDraftUrl = (draftId) => `/api/drafts/${draftId}`;

const getApiDraftUrlWithSuggestionId = (draftId, suggestionId) => `/api/drafts/${draftId}?suggestion_id=${suggestionId}`;

const getApiDraftUsersUrlWithDraftId = (draftId) => `/api${getTeamUrl()}/drafts/${draftId}/users`;

const getApiGoogleDriveIntegrationUrl = (userId) => `/api${getTeamUrl()}/users/${userId}/integrations/google-drive`;

const getApiNotionIntegrationUrl = (userId) => `/api${getTeamUrl()}/users/${userId}/integrations/notion`;

const getApiNotionSearchUrl = (userId, query, count) => `/api${getTeamUrl()}/users/${userId}/integrations/notion?searchQuery=${query}&count=${count}`;

const getApiTodoItemsUrl = (userId) => `/api${getTeamUrl()}/users/${userId}/todo`;

const getApiTodoCountUrl = () => `/api${getTeamUrl()}/users/${window.userId}/todo-count`;

const getApiCategoryUrl = (categoryId) => `/api${getCategoryUrl(categoryId)}`;

const getApiCreateDraftUrl = () => '/api/drafts/create';

const getApiCreateDraftUrlWithPageId = (page_id) => `${getApiCreateDraftUrl()}?page_id=${page_id}`;

const getApiCreateSuggestEditDraftwithPageId = (page_id) => `${getApiCreateDraftUrlWithPageId(page_id)}&suggestEdit=true`;

const getApiCreateDraftUrlWithSuggestionId = (suggestion_id) => `${getApiCreateDraftUrl()}?suggestion_id=${suggestion_id}`;

const getApiCreateDraftUrlWithQuestionId = (question_id) => `${getApiCreateDraftUrl()}?question_id=${question_id}`;

const getApiCreateDraftUrlWithSuggestionIdAndTemplateId = (
    suggestion_id,
    template_id,
) => `${getApiCreateDraftUrl()}?suggestion_id=${suggestion_id}&template_id=${template_id}`;

const getApiCreateDraftUrlWithPageIdAndSuggestionId = (
    page_id,
    suggestion_id,
) => `${getApiCreateDraftUrlWithPageId(page_id)}&suggestion_id=${suggestion_id}`;

const getApiCreateDraftUrlWithDuplicatePageId = (duplicate_page_id) => `${getApiCreateDraftUrl()}?duplicate_page_id=${duplicate_page_id}`;

const getApiCreateDraftUrlWithTemplateId = (template_id) => `${getApiCreateDraftUrl()}?template_id=${template_id}`;

const getApiCreateDraftUrlWithTemplatePageId = (template_page_id) => `${getApiCreateDraftUrl()}?template_page_id=${template_page_id}`;

const getApiCreateTemplateDraftUrl = () => `${getApiCreateDraftUrl()}?is_template=true`;

const getApiFolderUrl = (categoryId, folderId) => `/api${getFolderUrl(categoryId, folderId)}`;

const getApiOnboardingStatusUrl = () => `${getTeamApiUrl()}/onboarding-status`;

const getApiOnboardingStatusCountUrl = () => `${getTeamApiUrl()}/onboarding-status?count=true`;

const getApiUncategorizedItemsUrl = () => `/api${getTeamUrl()}/uncategorized`;

const getApiTeamPreferenceUrl = () => `/api${getTeamUrl()}/preferences`;

const getApiTeamSlackQaChannelsUrl = () => `${getTeamApiUrl()}/slack-qa-channels`;

const getApiTeamGoogleFoldersUrl = () => `${getTeamApiUrl()}/google-drive-folders`;

const getApiUserPreferenceUrl = () => `/api${getTeamUrl()}/users/${window.userId}/preferences`;

const getApiExternalResourceUrl = (externalResourceId) => `/api${getTeamUrl()}/links/${externalResourceId}`;

const getApiTeamTagsUrl = () => `/api${getTeamUrl()}/tags`;

const getApiPageUrl = (pageId) => `/api${getPagesUrl()}/${pageId}`;

const getApiPageTagsUrl = (pageId) => `${getApiPageUrl(pageId)}/tags`;

const getApiPageTagUrl = (pageId, tagId) => `${getApiPageUrl(pageId)}/tags/${tagId}`;

const getApiPageGenerateQuestionsUrl = (pageId) => `${getApiPageUrl(pageId)}/generate-questions`;

const getApiPageGenerateTagsUrl = (pageId) => `${getApiPageUrl(pageId)}/generate-tags`;

const getApiPageQuestionsUrl = (pageId) => `${getApiPageUrl(pageId)}/questions`;

const getApiPageAnsweredQuestionsUrl = (pageId) => `${getApiPageUrl(pageId)}/answered-questions`;

const getApiPageQuestionUrl = (pageId, questionId) => `${getApiPageUrl(pageId)}/questions/${questionId}`;

const getApiGeneratedQuestionsUrl = () => `/api${getTeamUrl()}/generated-questions`;

const getApiKaiSlackQuestionsUrl = (searchQueryId) => `/api${getTeamUrl()}/kai-slack-questions${searchQueryId ? `/${searchQueryId}` : ''}`;

const getApiGeneratedQuestionUrl = (questionId) => `/api${getTeamUrl()}/generated-questions/${questionId}`;

const getApiGeneratedAnswerUrl = (answerId) => `/api${getTeamUrl()}/generated-answers/${answerId}`;

const getApiQuestionGenerateAnswerUrl = (questionId) => `${getApiQuestionUrl(questionId)}/generate-answer`;

const getApiKaiAnswerReactionUrl = (answerId) => `${getApiGeneratedAnswerUrl(answerId)}/reactions`;

const getApiPagesUrl = () => `/api${getPagesUrl()}`;

const getApiDocumentUrl = (documentId) => `/api${getDocumentsUrl()}/${documentId}`;

const getApiLinkUrl = (linkId) => `/api${getLinksUrl()}/${linkId}`;

const getApiTemplateUrl = (templateId) => getApiPageUrl(templateId);

const getApiTemplatesUrl = () => `${getApiPagesUrl()}?templates=true`;

const getApiUsersAndGroupsUrl = () => `${getTeamApiUrl()}/usersAndGroups`;

const getApiCreateLinkVerificationSchedule = (link_id) => `${getApiExternalResourceUrl(link_id)}/verification-schedules`;

const getApiCreateDocumentVerificationSchedule = (document_id) => `${getApiDocumentUrl(document_id)}/verification-schedules`;

const getApiLinkVerificationSchedule = (
    link_id,
    link_verification_schedule_id,
) => `${getApiExternalResourceUrl(
    link_id,
)}/verification-schedules/${link_verification_schedule_id}`;

const getApiDocumentVerificationSchedule = (
    document_id,
    document_verification_schedule_id,
) => `${getApiDocumentUrl(
    document_id,
)}/verification-schedules/${document_verification_schedule_id}`;
const getApiLinkNotificationsUrl = (link_id) => `${getApiLinkUrl(link_id)}/notify`;

const getApiGetLinkVerificationAssigneesUrl = (link_id) => `${getApiExternalResourceUrl(link_id)}/verification-assignees`;

const getApiGetDocumentVerificationAssigneesUrl = (document_id) => `${getApiDocumentUrl(document_id)}/verification-assignees`;

const getApiLinkVerificationsUrl = (link_id) => `${getApiExternalResourceUrl(link_id)}/verifications`;

const getApiLinkVerificationUrl = (link_id, verification_id) => `${getApiExternalResourceUrl(link_id)}/verifications/${verification_id}`;

const getApiCreatePageVerificationSchedule = (page_id) => `${getApiPageUrl(page_id)}/verification-schedules`;

const getApiUpdatePageVerificationSchedule = (
    page_id,
    verification_schedule_id,
) => `${getApiPageUrl(
    page_id,
)}/verification-schedules/${verification_schedule_id}`;

const getApiGetVerificationAssigneesUrl = (page_id) => `${getApiPageUrl(page_id)}/verification-assignees`;

const getApiPageVerificationsUrl = (page_id) => `${getApiPageUrl(page_id)}/verifications`;

const getApiPageVerificationUrl = (page_id, verification_id) => `${getApiPageUrl(page_id)}/verifications/${verification_id}`;

const getApiDocumentVerificationsUrl = (document_id) => `${getApiDocumentUrl(document_id)}/verifications`;

const getApiDocumentNotificationsUrl = (document_id) => `${getApiDocumentUrl(document_id)}/notify`;

const getApiPageVerificationSchedule = (page_id, verification_schedule_id) => `${getApiPageUrl(
    page_id,
)}/verification-schedules/${verification_schedule_id}`;

const getTemplatesUrlFromCategoryIdAndFolderId = (categoryId, folderId) => `${getTeamApiUrl()}/categories/${categoryId}/templates?folderId=${folderId}`;

const getApiPageUrlWithToken = (pageId, token) => (token
    ? `/api${getPagesUrl()}/${pageId}?auth=${token}`
    : `/api${getPagesUrl()}/${pageId}`);

const getApiSluggedPageUrlWithToken = (slug, token) => (token
    ? `/api${getSluggedPagesUrl()}/${slug}?auth=${token}`
    : `/api${getSluggedPagesUrl()}/${slug}`);

const getApiRevisionUrl = (revisionId) => `/api${getTeamUrl()}/revisions/${revisionId}`;

const getApiStalePagesUrl = () => `/api${getTeamUrl()}/content-suggestions`;

const getApiUnownedPagesUrl = () => `/api${getTeamUrl()}/content-suggestions/unowned`;

const getApiScheduledRequestsUrl = () => `/api${getTeamUrl()}/scheduled-suggestions`;

const getApiScheduledRequestUrl = (id) => `/api${getTeamUrl()}/scheduled-suggestions/${id}`;

const getApiPublicPagesUrl = () => `/api${getTeamUrl()}/content-suggestions/public`;

const getApiSuggestedUpdatesUrl = () => `/api${getTeamUrl()}/content-suggestions/suggested-updates`;

const getApiVerificationSchedulesUrl = () => `/api${getTeamUrl()}/verification-schedules`;

const getApiQuestionsUrl = () => `/api${getTeamUrl()}/questions`;

const getApiQuestionUrl = (questionId) => `/api${getTeamUrl()}/questions/${questionId}`;

const getApiCategoryQuestionsUrl = (id) => `/api${getTeamUrl()}/categories/${id}/questions`;

const getApiSubcategoryQuestionsUrl = (id) => `/api${getTeamUrl()}/subcategories/${id}/questions`;

const getApiQuestionReactionsUrl = (questionId) => `/api${getTeamUrl()}/questions/${questionId}/reactions`;

const getApiQuestionReactionUrl = (questionId, reactionId) => `/api${getTeamUrl()}/questions/${questionId}/reactions/${reactionId}`;

const getApiUploadExternalImageUrl = () => '/api/external-images';

const getApiUploadBase64ImageUrl = () => '/api/base64-images';

const getExternalSitesUrl = () => `${getTeamUrl()}/external-sites`;

const getExternalSiteUrl = (externalSiteId) => `${getExternalSitesUrl()}/${externalSiteId}`;

const getUpgradePlanUrl = () => `${getTeamUrl()}/upgrade-plan`;

const getPageSlugFromUrl = (url) => url.match(/pages\/([^?]+)/)[1];

const getPageUrlFromPageId = (page_id) => `${getTeamUrl()}/page-ids/${page_id}`;

const getUpdatePageUrlFromPageIdAndSuggestionId = (pageId, suggestionId) => `${getPageUrlFromPageId(pageId)}/edit?suggestionId=${suggestionId}`;

const getPageVerificationScheduleModalUrlFromPageId = (page_id) => `${getPageUrlFromPageId(page_id)}?showVerificationModal=true`;

const getPageUrlFromSlug = (slug) => `${getTeamUrl()}/pages/${slug}`;

const getPageDashboardPinUrlFromSlug = (slug) => `${getPageUrlFromSlug(slug)}/pin`;

const getEditPageUrlFromSlug = (slug) => `${getPageUrlFromSlug(slug)}/edit`;

const getSuggestEditUrlFromSlug = (slug) => `${getEditPageUrlFromSlug(slug)}?suggestEdit=true`;

const getRevisionsUrlFromSlug = (slug) => `${getPageUrlFromSlug(slug)}/revisions`;

const getUserUrl = (userId) => `${getTeamUrl()}/users/${userId}`;

const getInvitationUrl = (invitationId) => `${getTeamUrl()}/invitations/${invitationId}`;

const getBookmarkUrl = (userId) => `${getUserUrl(userId)}/bookmarks`;

const getUserIntegrationsUrl = (userId) => `${getUserUrl(userId)}/integrations`;

const getUserGroupsUrl = () => `${getTeamUrl()}/groups`;

const isDashboardUrl = () => window.location.pathname === getTeamUrl();

const isKaiDashboardUrl = () => window.location.pathname.includes(getKaiDashboardUrl());

const isUserTodosUrl = (userId) => window.location.pathname === getUserProfileUrl(userId);

const isUserOwnedPagesUrl = (userId) => window.location.pathname === getUserOwnedPagesUrl(userId);

const isUserOwnedCategoriesUrl = (userId) => window.location.pathname === getUserOwnedCategoriesUrl(userId);

const isUserSuggestionsUrl = (userId) => window.location.pathname === getUserSuggestionsUrl(userId);

const isUserAnsweredQuestionsUrl = (userId) => window.location.pathname === getUserAnsweredQuestionsUrl(userId);

const isUserLinksUrl = (userId) => window.location.pathname === getUserLinksUrl(userId);

const isUserDocumentsUrl = (userId) => window.location.pathname === getUserDocumentsUrl(userId);

const isSetupGuideUrl = () => window.location.pathname === getSetupGuideUrl();

const isInternalLinkUrl = (url) => {
    const _url = new URL(url);
    return _url.pathname.startsWith(`/teams/${window.teamDomain}/`);
};

const isUserProfileUrl = (userId) => isUserTodosUrl(userId)
  || isUserOwnedPagesUrl(userId)
  || isUserOwnedCategoriesUrl(userId)
  || isUserSuggestionsUrl(userId)
  || isUserAnsweredQuestionsUrl(userId)
  || isUserLinksUrl(userId)
  || isUserDocumentsUrl(userId);

const isPagesUrl = () => window.location.pathname === getPagesUrl();

const isSuggestionsUrl = () => window.location.pathname === getSuggestionsUrl();

const isQuestionsUrl = () => window.location.pathname === getQuestionsUrl();

const isTemplatesUrl = () => window.location.pathname === getTemplatesUrl();

const isContentSuggestionsUrl = () => window.location.pathname === getContentSuggestionsUrl();

const isArchivedPagesUrl = () => window.location.pathname === getArchivedPagesUrl();

const getApiPageDashboardPinUrlFromSlug = (slug) => `/api${getPageUrlFromSlug(slug)}/pin`;

const getApiTeamDashboardPinUrl = () => `/api${getTeamUrl()}/pins`;

const getApiTeamCategoryFolderUrl = (categoryId, folderId) => `/api${getTeamUrl()}/categories/${categoryId}/folders/${folderId}`;

const getCreateSlackPermissionsUrl = (tettraScope = 'team', returnUrl) => {
    let url = `${getTeamUrl()}/slack-permissions/create?tettraScope=${tettraScope}`;
    if (returnUrl) {
        url += `&returnUrl=${returnUrl}`;
    }

    return url;
};

const getConnectGoogleUrl = (userId, returnUrl) => {
    let url = `${getUserIntegrationsUrl(userId)}/google`;
    if (returnUrl) {
        url += `?returnUrl=${returnUrl}`;
    }

    return url;
};

const getAccountSharingLogoutUrl = () => '/logout?account-sharing=true';

const getApiTeamEmailVerificationStatusUrl = () => `/api${getTeamUrl()}/check-email-verification`;

const getLogoutUrl = () => '/logout';

export {
    getArchivedPagesUrl,
    getArchivedPagesSearchViewUrl,
    getArchivedPageUrl,
    getRestorePageUrl,
    getContentSuggestionsUrl,
    getCreateDraftUrl,
    getCreateDraftUrlWithQuestionId,
    getCreateDraftUrlFromCategoryIdAndFolderId,
    getCreateDraftUrlFromCategoryId,
    getCreateDraftUrlFromTemplateId,
    getCreateDraftUrlFromPageId,
    getCreateSuggestionUrlFromCategoryId,
    getCreateSuggestionUrlFromCategoryIdAndFolderId,
    getCreateDraftUrlFromFolderId,
    getUpdatePageUrlFromPageIdAndSuggestionId,
    getCreateTemplateUrlFromPageId,
    getCreateDraftUrlFromSuggestionId,
    getDraftUrl,
    getEditDraftUrl,
    getExportUrl,
    getDraftEditApprovalUrl,
    getApiAnswerThankYousUrl,
    getApiAnswerThankYouUrl,
    getApiActivitiesUrl,
    getApiBookmarkUrl,
    getApiCreateDraftUrl,
    getApiDraftUrl,
    getApiDraftUrlWithSuggestionId,
    getApiDraftUsersUrlWithDraftId,
    getApiGoogleDriveIntegrationUrl,
    getApiNotionIntegrationUrl,
    getApiNotionSearchUrl,
    getApiCreateDraftUrlWithSuggestionId,
    getApiCreateDraftUrlWithQuestionId,
    getApiCreateDraftUrlWithSuggestionIdAndTemplateId,
    getApiCreateDraftUrlWithPageId,
    getApiCreateSuggestEditDraftwithPageId,
    getApiCreateDraftUrlWithDuplicatePageId,
    getApiCreateDraftUrlWithPageIdAndSuggestionId,
    getApiCreateDraftUrlWithTemplateId,
    getApiCreateDraftUrlWithTemplatePageId,
    getApiCreatePageVerificationSchedule,
    getApiUpdatePageVerificationSchedule,
    getApiDocumentNotificationsUrl,
    getApiLinkNotificationsUrl,
    getApiPageVerificationSchedule,
    getApiCreateTemplateDraftUrl,
    getApiOnboardingStatusUrl,
    getApiOnboardingStatusCountUrl,
    getApiTodoItemsUrl,
    getApiTodoCountUrl,
    getApiCategoryUrl,
    getApiFolderUrl,
    getApiTeamTagsUrl,
    getApiPageUrl,
    getApiPagesUrl,
    getApiPageUrlWithToken,
    getApiSluggedPageUrlWithToken,
    getApiRevisionUrl,
    getApiTemplateUrl,
    getApiTemplatesUrl,
    getTemplatesUrlFromCategoryIdAndFolderId,
    getApiUncategorizedItemsUrl,
    getApiTeamPreferenceUrl,
    getApiUserPreferenceUrl,
    getApiUsersAndGroupsUrl,
    getApiPageVerificationsUrl,
    getApiPageVerificationUrl,
    getApiVerificationSchedulesUrl,
    getApiQuestionsUrl,
    getApiQuestionUrl,
    getApiCategoryQuestionsUrl,
    getApiSubcategoryQuestionsUrl,
    getApiQuestionReactionsUrl,
    getApiQuestionReactionUrl,
    getApiPublicPagesUrl,
    getApiUnownedPagesUrl,
    getApiStalePagesUrl,
    getApiSuggestedUpdatesUrl,
    getApiUploadBase64ImageUrl,
    getApiUploadExternalImageUrl,
    getDocumentsUrl,
    getExternalSitesUrl,
    getExternalSiteUrl,
    getCategoriesUrl,
    getCreateCategoryUrl,
    getCategoryEditUrl,
    getCategoryUrl,
    getFolderUrl,
    getEditPageUrlFromSlug,
    getSuggestEditUrlFromSlug,
    getExternalResourceUrl,
    getRestoreExternalResourceUrl,
    getArchivedExternalResourceUrl,
    getDocumentUrl,
    getSlackFilesUrl,
    getCreateSlackPermissionsUrl,
    getConnectGoogleUrl,
    getOnboardingTeamUrl,
    getOnboardingGsuiteIntegrationUrl,
    getOnboardingCreateFirstQuestionUrl,
    getOnboardingSlackIntegrationUrl,
    getSuggestionsUrl,
    getQuestionsUrl,
    getQuestionUrl,
    getQuestionUrlAnswerAction,
    getSuggestionUrl,
    getSuggestionEditUrl,
    getSuggestionCloseUrl,
    getSubcategoriesUrl,
    getSubcategoryUrl,
    getSubcategoryEditUrl,
    getUpgradePlanUrl,
    getTeamUrl,
    getKaiDashboardUrl,
    getApiTeamKaiExcludedCategoriesUrl,
    getTeamSettingsUrl,
    getTeamUsersUrl,
    getTeamBillingUrl,
    getTeamIntegrationsUrl,
    getTemplatesUrl,
    getPageDashboardPinUrlFromSlug,
    getApiPageDashboardPinUrlFromSlug,
    getPageSlugFromUrl,
    getPageUrlFromPageId,
    getPageVerificationScheduleModalUrlFromPageId,
    getPageUrlFromSlug,
    getPagesUrl,
    getPagesOwnerUrl,
    getUncategorizedPagesUrl,
    getPageSearchUrl,
    getCategoryPinUrl,
    getRevisionsUrlFromSlug,
    getUserUrl,
    getInvitationUrl,
    getBookmarkUrl,
    getUserIntegrationsUrl,
    getUserGroupsUrl,
    isDashboardUrl,
    isKaiDashboardUrl,
    isInternalLinkUrl,
    isPagesUrl,
    isSuggestionsUrl,
    isQuestionsUrl,
    isTemplatesUrl,
    isContentSuggestionsUrl,
    isArchivedPagesUrl,
    isSetupGuideUrl,
    getApiGetVerificationAssigneesUrl,
    getApiCreateLinkVerificationSchedule,
    getApiLinkVerificationSchedule,
    getApiGetLinkVerificationAssigneesUrl,
    getApiLinkVerificationsUrl,
    getApiLinkVerificationUrl,
    getApiTeamCategoryFolderUrl,
    getUserProfileUrl,
    isUserProfileUrl,
    getUserOwnedPagesUrl,
    getUserOwnedCategoriesUrl,
    getUserSuggestionsUrl,
    getUserAnsweredQuestionsUrl,
    getUserLinksUrl,
    getUserDocumentsUrl,
    getApiScheduledRequestsUrl,
    getApiScheduledRequestUrl,
    getLogoutUrl,
    getAccountSharingLogoutUrl,
    getApiPageTagsUrl,
    getApiPageTagUrl,
    getApiPageQuestionsUrl,
    getApiPageQuestionUrl,
    getApiGeneratedQuestionsUrl,
    getApiGeneratedQuestionUrl,
    getApiKaiSlackQuestionsUrl,
    getGeneratedQuestionsUrl,
    getGeneratedQuestionUrl,
    getKaiSlackQuestionsUrl,
    getKaiSlackQuestionUrl,
    getApiGeneratedAnswerUrl,
    getApiQuestionGenerateAnswerUrl,
    getApiPageGenerateTagsUrl,
    getApiPageGenerateQuestionsUrl,
    getApiPageAnsweredQuestionsUrl,
    getApiKaiAnswerReactionUrl,
    getOnboardingKaiUrl,
    getOnboardingEnableKaiUrl,
    getApiCreateDocumentVerificationSchedule,
    getApiGetDocumentVerificationAssigneesUrl,
    getApiDocumentVerificationSchedule,
    getApiDocumentVerificationsUrl,
    getArchivedDocumentUrl,
    getRestoreDocumentUrl,
    getApiTeamSlackQaChannelsUrl,
    getTeamSlackQaChannelsUrl,
    getApiTeamDashboardPinUrl,
    getApiTeamEmailVerificationStatusUrl,
    getSetupGuideUrl,
    getApiTeamGoogleFoldersUrl,
    getTeamGoogleFoldersUrl,
};
